
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Qualitypi.module.css';

const Qualitykpi = ({ title, value }) => {
  return (
    <div className={styles['stat-tile']}>
      <div className={styles['tile-header']}>{title}</div>
      <div className={styles['tile-body']}>
        <div className={styles['tile-value']}>{value}</div>
      </div>
      <div className={styles['tile-footer']} />
    </div>
  );
};

Qualitykpi.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,

};

Qualitykpi.defaultProps = {
  isPositive: true
};

export default Qualitykpi;
